import {styled, TextField} from '@mui/material';

export const TextInput = styled(TextField)({
  '& .MuiInputBase-root': {
    background: 'rgba(0,0,0,0.05)',
    borderRadius: '12px',
  },
  '& label': {
    color: '#00000080',
  },
  '& label.Mui-focused': {
    color: '#00000080',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderRadius: '12px',
      borderColor: 'rgba(0, 0, 0, 0.1)',
    },
    '&:hover fieldset': {
      borderColor: 'rgba(0, 0, 0, 0.15)',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'rgba(0, 0, 0, 0.15)',
    },
  },
});
